import { render, staticRenderFns } from "./jgDetails.vue?vue&type=template&id=10681022&scoped=true"
import script from "./jgDetails.vue?vue&type=script&lang=js"
export * from "./jgDetails.vue?vue&type=script&lang=js"
import style0 from "./jgDetails.vue?vue&type=style&index=0&id=10681022&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10681022",
  null
  
)

export default component.exports